export const FLUSS_PROPERTIES_WIDTH_STORAGE_KEY = "fluss-studio.properties-panel-width";
export const FLUSS_PROPERTIES_WIDTH_DEFAULT = 400;
export const FLUSS_PROPERTIES_WIDTH_MIN = 320;
export const FLUSS_PROPERTIES_WIDTH_MAX = 640;

export const clampPropertiesWidth = (value: number) =>
    Math.min(FLUSS_PROPERTIES_WIDTH_MAX, Math.max(FLUSS_PROPERTIES_WIDTH_MIN, value));

export const loadStoredPropertiesWidth = (storage?: Pick<Storage, "getItem">) => {
    if (!storage) return FLUSS_PROPERTIES_WIDTH_DEFAULT;
    const raw = storage.getItem(FLUSS_PROPERTIES_WIDTH_STORAGE_KEY);
    if (raw === null) return FLUSS_PROPERTIES_WIDTH_DEFAULT;
    const stored = Number(raw);
    return Number.isFinite(stored) && stored > 0
        ? clampPropertiesWidth(stored)
        : FLUSS_PROPERTIES_WIDTH_DEFAULT;
};
